import './Video.scss';
function Video() {
    return (
        <div className='container'>
            <div className='video'>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/vYcClw_vCew" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                </iframe>
            </div>
        </div>
    )
}
export default Video;